module.exports = __webpack_public_path__ + "media/images/front/join_dplus_slide-d3bfb0284e35b20ab1fc10100ff40572.jpg";